import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";
import {appLink} from "@web2/gh_routes";
import {parseDeveloperSlugToObject} from "@web2/gh_routes";

import {IVendorBox} from "../../application/actions/fetch_vendor_list_at_route";
import {VendorType} from "../../offer/detail/components/agency_and_developer/agency_and_developer_utils";

interface IVendorBoxProps extends IVendorBox {
    vendorType: VendorType;
}

export const VendorBox = (props: IVendorBoxProps) => {
    const {logo_picture, name, offer_summary, slug, vendorType} = props;
    const href =
        vendorType === VendorType.DEVELOPER ? appLink.developer.detail.base(parseDeveloperSlugToObject(slug)) : appLink.agency.detail({agencySlug: slug});

    return (
        <a css={agencyBoxLink} href={href} title={`Agencja ${name}`}>
            <AgencyBoxWrapper>
                <div css={agencyBoxLogo}>{logo_picture && logo_picture.a_log_100 && <img src={logo_picture.a_log_100} alt={`${name}`} />}</div>

                <div css={agencyBoxName}>{name}</div>
                <div css={agencyBoxText}>
                    <strong>{offer_summary.offer_count}</strong> nieruchomości
                    <br /> w ofercie
                </div>
            </AgencyBoxWrapper>
        </a>
    );
};

const AgencyBoxWrapper = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 2rem;
    border: 0.1rem solid ${(props) => props.theme.colors.gray_very_bright};
    border-radius: ${(props) => props.theme.borders.border_radius_base};
    overflow: hidden;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.screen_lg}) {
        height: 26rem;
        width: 28.125rem;
    }
`;

const agencyBoxLogo = css`
    display: flex;
    align-items: center;
    justify-items: center;
    height: 8.976rem;
`;

const agencyBoxName = (theme: Theme) => css`
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 2.4rem;
    text-align: center;
    color: ${theme.colors.brand_primary};
`;

const agencyBoxText = css`
    text-align: center;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.6rem;
`;

const agencyBoxLink = (theme: Theme) => css`
    all: unset;
    cursor: pointer;

    &:hover,
    &:active {
        all: unset;
        cursor: pointer;
        box-shadow: 0 2px 21px 2px rgba(0, 0, 0, 0.2);
    }
`;
